import React from 'react';

import { withStyles } from '@material-ui/core/styles';

import { Typography, Button } from '@material-ui/core';

import styles from '../config/styles';

class OpenPositions extends React.Component {
    render() {
        const { classes } = this.props;
        return (
            <section id="openPositions" className={[classes.section, classes.longSection , classes.greySection].join(" ")}>
                <div className={classes.innerBox}>
                    <div className={classes.innerHeaderSection}>
                        <Typography variant="h4" >
                            We are the looking for super heroes
                        </Typography>
                        <Typography variant="subtitle1" style={{ letterSpacing: 0 }}>
                            We are growing, you will be one of the early people to join our team and will have the opportunity to freely define and expand your role as you see fit.
                        </Typography>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', marginBottom: 15 }}>

                        <Button variant='outlined' target="_blank" href="https://getriku.zohorecruit.in/jobs/2021" >See All Openings</Button>
                    </div>

                    <div style={{ width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>

                        <Typography variant="caption" align='center' style={{ padding: 5 }}>
                            Want you make your own role ? Tell us why at <a href="mailto:careers@ftlabs.io" style={{ textDecoration: 'none' }}>careers@ftlabs.io</a>
                        </Typography>
                    </div>
                </div>
            </section>
        )
    }
}


export default withStyles(styles)(OpenPositions);